(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.LTCTraining",
                {
                    url: "/LTCTraining",
                    component: "ltctraining",
                    PageTitle: "Long Term Care Training",
                    requiredPermissions: "LtcTraining:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("ltctraining",
        {
            templateUrl: "App/Resources/LTCTraining/LTCTraining.html",
            controller: ltcTriningCtrl,
            bindings: {
                states: "<"
            }
        });

    ltcTriningCtrl.$inject = ["$filter", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "wistiaApi", "permissionService", "amplitudeService"];

    function ltcTriningCtrl($filter, eligibilityFormDialog, surveys, eligibilityFormApi, wistiaApi, permissionService, amplitudeService) {

        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
        console.log(surveys)
        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.longTermCareTrainingId).then(function (response) {
                $ctrl.submitted = response;
            });
        });

        $ctrl.loadResources = function () {

            $ctrl.loadingAssets = true;
            wistiaApi.getLtcTrainingAssets().then(function (response) {
                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {

                    var newAsset =
                    {
                        ShowSection: true,
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: $filter("filter")(projectMedias, { section: value.section }, true)
                    };
                    $ctrl.Assets.push(newAsset);


                    ng.forEach($ctrl.Assets, function (asset, key) {
                        if (!permissionService.hasOnePermission("LtcTraining:Access")) {

                            if (asset.Title === "2018 Sessions") {
                                asset.ShowSection = false;
                            }
                            if (asset.Title === "2017 Sessions") {
                                asset.ShowSection = false;
                            }
                            if (asset.Title === "2016 Sessions") {
                                asset.ShowSection = false;
                            }
                            if (asset.Title === "LTC Files - Jan Berry") {
                                asset.ShowSection = false;
                            }
                            if (asset.Title === "Client Newsletter") {
                                asset.ShowSection = false;
                            }
                            if (asset.Title === "Powerpoints and Illustrations") {
                                asset.ShowSection = false;
                            }
                        }

                    });
                });

            }).then(function () {
                $ctrl.loadingAssets = false;
            });
        };

        $ctrl.closeOtherAssets = function (asset) {
            ng.forEach($ctrl.Assets, function (a, key) {
                if (a.ID !== asset.ID)
                    a.Active = false;
            });
        }

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.longTermCareTrainingId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        if (permissionService.hasOnePermission("LtcTraining:View")) {
            $ctrl.loadResources();
        }
    }

})(window.app, window.angular); // jshint ignore:line